/* eslint-disable no-use-before-define */
import React from 'react';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import LongText from '../../../Elements/LongText';

export default class ProjectAssociableTpWaveItem {
  constructor(item) {
    if (item === undefined) {
      this.Selected = false;
      this.TpWaveId = '';
      this.ThirdPartyWaveName = '';
      this.ThirdPartyWaveId = '';
      this.ThirdPartyClientId = '';
      this.ThirdPartySource = '';

      return;
    }
    this.Selected = item.selected;
    this.TpWaveId = item.tpWaveId;
    this.ThirdPartyWaveName = item.thirdPartyWaveName;
    this.ThirdPartyWaveId = item.thirdPartyWaveId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.ThirdPartySource = item.thirdPartySource;
  }

  static NameOfTheIdField() {
    return 'TpWaveId';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['CreatedOnUtc', 'ModifiedOnUtc'];
  static BoolFields = [];

  static nameOfTheItemDetailList(item) {
    return item.ThirdPartyClientName;
  }

  static FieldsToShowInDataTable() {
    // prettier-ignore
    return [
      { label: 'Selected', orderById: '', data: ProjectAssociableTpWaveItem.getSelectedCellContent, minWidth: 20 },
      {
        label: 'Id',
        orderById: 'ThirdPartyWaveId',
        data: 'ThirdPartyWaveId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartyWaveName',
        data: (item) => (
          <LongText
            text={item.ThirdPartyWaveName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
    ];
  }

  static clickOnSelect(item) {
    alert('Click');
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onClick={(e) => {
            ProjectAssociableTpWaveItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }
}
